export const BASE_URL = process.env.REACT_APP_BASE_URL;
export class Endpoint {
  // MARK: USER
  static REGISTER_USER = "requestApplication";
  static LOGIN = "login";
  static GET_USER = "user/details";
  static UPDATE_USER = "user/update";
  static REFRESH_TOKEN = "refreshToken";
  static VERIFY_EMAIL_OTP = "email/otp/verify";
  static VERIFY_OTP = "otp/verify";
  static SEND_EMAIL_OTP = "send/email/otp";
  static RESEND_OTP = "otp/resend";
  static REQUEST_PASSWORD_CHANGE = "otp/password/change";
  static UPDATE_USER_PASSWORD_OTP = "user/update/password/otp";
  static MEMMON_ID_CARD = "user/memonid";
  static ASSIGN_JAMAAT_ADMIN = "jamaat/admin/assign";
  static ASSIGN_ROLES = "role/assign";
  static CHANGE_PASSWORD = "user/password/change";
  static DISABLE_ACCOUNT = "user/account/disable";
  static DELETE_ACCOUNT = "user/delete";

  // MARK: Cities
  static GET_CITIES = "cities";
  static ADD_CITY = "city/add";
  static DELETE_CITY = "city/delete";

  // MARK: Jamat
  static GET_JAMAATS = "getAllJamatDetails";
  static GET_ALL_JAMAATS = "jamaats";
  static GET_JAMAAT_PAGES = "jamaats/pages";
  static ADD_JAMAAT = "jamaat/add";
  static UPDATE_JAMAAT = "jamaat/update";
  static DELETE_JAMAAT = "jamaat/delete";

  // MARK: Notification
  static GET_ALL_NOTIFICATIONS = "admin/notifications";
  static GET_USER_NOTIFICATIONS = "user/notifications";
  static GET_NOTIFICATION_PAGES = "notifications/pages";
  static ADD_NOTIFICATION = "notification/add";
  static UPDATE_NOTIFICATION = "notification/update";
  static DELETE_NOTIFICATION = "notification/delete";
  static CHANGE_NOTIFICATION_STATUS = "notification/change/status";

  // MARK: Members
  static GET_ALL_MEMBERS = "members";
  static GET_MEMBER_PAGES = "members/pages";
  static ADD_MEMBER = "member/add";
  static UPDATE_MEMBER = "member/update";

  // MARK: Applicants
  static GET_APPLICANTS = "applicants";
  static GET_APPLICANTS_PAGES = "applicants/pages";
  static UPDATE_USER_APPROVAL = "user/update/approval";

  // MARK: Reserved code
  static GET_ALL_RESERVED_CODES = "reservedcodes";
  static ADD_RESERVED_CODE = "reservedcode/add";
  static DELETE_RESERVED_CODE = "reservedcode/delete";
  static ASSIGN_RESERVED_CODE = "reservedcode/assign";

  // MARK: FAMILY
  static GET_SEARCH_USERS = "user/search";
  static ADD_RELATION = "/relation/add";
  static GET_APPROVAL = "/relation/approvals";
  static GET_RELATION_REQUESTS = "/relation/requests";
  static UPDATE_RELATION = "/relation/update";
  static DELETE_RELATION = "/relation/delete";
  static FAMILY_TREE = "family/tree";

  // MARK: NEWS
  static ADD_NEWS = "/news/add";
  static UPDATE_NEWS = "/news/update";
  static DELETE_NEWS = "/news/delete";
  static GET_NEWS = "/news";
  static GET_NEWS_APPROVALS = "/news/approvals";
  static GET_NEWS_SELF = "/news/self";

  // MARK: STORIES
  static ADD_STORIES = "/stories/add";
  static UPDATE_STORIES = "/stories/update";
  static DELETE_STORY = "/stories/delete";
  static GET_STORIES = "/stories";
  static GET_STORIES_APPROVALS = "/stories/approvals";
  static GET_STORIES_SELF = "/stories/self";

  static UPLOAD_FILE = "/uploadFile";

  // MARK: HELPLINE
  static ADD_HELPLINE_CONTACTS = "/helplineContact/add";
  static UPDATE_HELPLINE_CONTACTS = "/helplineContacts/update";
  static DELETE_HELPLINE_CONTACTS = "/helplineContacts/delete";
  static GET_HELPLINE_CONTACTS = "/getAllHelplineContacts";
  static ADD_HELPLINE = "/helpline/add";
  static UPDATE_HELPLINE = "/helpline/update";
  static GET_OWN_HELP_REQUESTS = "/getOwnHelplines";
  static DELETE_HELPLINE = "/helpline/delete";
  static GET_HELPLINE_APPROVAL = "/getPendingHelplines";
  static GET_HELPLINE = "/helpline";

  // MARK: AWARDS
  static ADD_AWARD = "/awards/add";
  static UPDATE_AWARD = "/awards/update";
  static GET_AWARDS_PAGES = "/awards/pages";
  static GET_AWARDS_ADMIN = "/awards/admin";
  static GET_AWARDS_USER = "/awards";
  static ADD_AWARD_VOTE = "/awards/vote";
  static DELETE_AWARD = "/awards/delete";

  // MARK: EVENTS

  static GET_ALL_EVENTS = "/events/admins";
  static GET_MONTH_EVENTS = "/events/month";
  static GET_USER_EVENTS = "/events/user";
  static ADD_EVENTS = "/events/add";
  static UPDATE_EVENTS = "/events/update";
  static DELETE_EVENTS = "/events/delete";
  // static GET_EVENTS_PAGES = "notifications/pages";
}

// ------------------------------ Status codes ---------------------------

export class Status {
  static API_SUCCESS = 200;
  static API_CREATED = 201;
  static API_ACCEPTED = 202;
  static API_NO_CONTENT = 204;
  static API_BAD_REQUEST = 400;
  static API_UNAUTHORIZED = 401;
  static API_FORBIDDEN = 403;
  static API_NOT_FOUND = 404;
  static API_METHOD_NOT_ALLOWED = 405;
  static API_CONFLICT = 409;
  static API_INTERNAL_SERVER_ERROR = 500;
  static API_SESSION_EXPIRED = 440;
}

// ------------------------------ Error Status codes ---------------------------

export class ErrorStatus {
  static BAD_REQUEST = 400;
  static UNAUTHORIZED = 401;
  static NOT_FOUND = 404;
  static FORBIDDEN = 403;
  static INTERNAL_SERVER_ERROR = 500;
}
